// Async boundary mirroring the shell's index.ts. The dynamic import keeps the
// entry chunk tiny so the `config` chunk (window.IntegrationsAppConfig, injected
// by runtimeConfigPlugin as a classic defer script ahead of `main`) is
// evaluated before bootstrap reads any config.
import("./bootstrap");
